<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="文件名称:" prop="fileName">
                        <el-input
                        v-model="queryParams.fileName"
                        placeholder="请输入文件名称"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <el-upload style="display: inline-block;margin-left:10px;"
                            class="upload-demo"  action="#"            
                            :http-request="customUpload"  :before-upload="beforeUpload"
                            :show-file-list="false" @change="handleChange">
                            <el-button size="small" type="warning" icon="el-icon-upload2">上传</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="chackcaseList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="id" prop="id" width="100" />
                    <el-table-column label="文件名称" prop="fileName" />
                    <el-table-column label="上传时间" align="center" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.createTime">{{ getDate2(scope.row.createTime) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.pdfToImageStates == 0">解析中...</span>
                            <span v-else>已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="预览" align="center" width="180">
                        <template slot-scope="scope">
                            <span style="color:#1890ff;cursor:pointer;" @click="showPdf(scope.row.fileUrl)">预览PDF</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                            <el-button v-if="Number(scope.row.splitQuantity) > 1"
                                size="small"
                                type="text"
                                @click="handleSplit(scope.row)"
                            >拆分文件</el-button>
                            <el-button
                                size="small"
                                type="text"
                                @click="handleShow(scope.row)"
                            >查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <el-dialog title="拆分文件" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
            <div class="box-cont">
                <el-table v-loading="loading" :data="fileList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{scope.$index+1}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="拆分文件" >
                        <template slot-scope="scope">
                            <span style="color:#1890ff;cursor:pointer;" @click="showPdf(scope.row.followFileurl)">{{scope.row.followFileurl}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
        <el-dialog title="AI智能案卷评查" :visible.sync="open2" top="5vh" width="90%" append-to-body :close-on-click-modal="false" class="pcTk">
            <zncf :pcId="this.pcId" :ispc="this.ispc" :row="this.row" @handleCall="handleCall" />
        </el-dialog>
    </div>
</template>

<script>
import Zncf from './zncf.vue'
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            dm:'',
            queryParams:{
                fileName:'',
                page:1,
                limit:10,
            },
            times:[],
            times2:[],
            total:0,
            chackcaseList:[],
            currentPage:1,
            pagesize:10,
            open3:false,
            pcId:'',
            row:{},
            open5:false,
            formR:{},
            ispc:0,
            pageshow:true,
            fileList: [],
            total2:0,
            open:false,
            open2:false,
            baseUrl:''
        }
    },
    components: {
        Zncf
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        
        this.getList()
    },
    methods: {
        beforeUpload(file){
            // 进行文件验证
            const isPDF = file.type === 'application/pdf';
            //const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isPDF) {
                this.$message.error('只能上传 PDF 文件!');
            }
            //if (!isLt2M) {
            //    this.$message.error('文件大小不能超过 2MB!');
            //}
            return isPDF;
        },
        handleChange(file, fileList) {
            console.log(file,171)
        },
        customUpload(options) {
            console.log(options,160)
            const formData = new FormData();
            formData.append('file', options.file);
            // 添加其他参数
            formData.append('dm', this.dm);
            formData.append('cmid', this.cmid);

            this.$axios.post(this.baseUrl+`/pdfApi/upload`, formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            })
            .then(response => {
                console.log('上传成功:', response.data);
                this.$message.success('上传成功!');
                this.getList()
            })
            .catch(error => {
                console.error('上传失败:', error);
                this.$message.error('上传失败!');
            });
        },
        handleSplit(row){
            this.total2 = 0
            this.fileList = []
            console.log(row,this.fileList)
            this.open = true
            this.fileList = row.list
            this.total2 = this.fileList.length
        },
        async getList(){
            this.chackcaseList = []
            this.total = 0
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/pdfApi/PdfList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    fileName:this.queryParams.fileName,
                    dm:this.dm,
                    cmid:this.cmid,
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.chackcaseList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                console.error('There was an error!', error);
            });
        },
        showPdf(fileUrl){
            if(fileUrl){
                let url = this.baseUrl+`` + fileUrl + '?response-content-type=application/pdf'
                window.open(url,'_blank')
            }else{
                this.$message.error('当前PDF文件不存在，请联系管理员查看！！！')
            }
        },
        handleShow(row){
            this.$message.error('系统正在优化，请稍后再试...')
            //this.open2 = true
            this.pcId = row.id
            this.ispc = Number(row.reviewStatus)
            this.row = row
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.currentPage = 1
            this.queryParams = {
                fileName:'',
                page:1,
                limit:10,
            }
            this.getList()
        }, 
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        anjuanPingce(row){
            this.pcId = row.lsh
            this.row = row
            this.ispc = Number(row.isPingce)
            this.open3 = true
        },
        handleBack(row){
            this.$confirm("您是否确定要退回该案件。是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/setAnjianStates`,
                    data:{
                        pcId: row.lsh,
                        states:0
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0){
                        this.open = false
                        this.getList()
                    }else{
                        this.$message({
                            message: res.data.data+',提交失败，请重新操作！',
                            type: 'error'
                        });
                        setTimeout(()=>{
                            this.handleShow(lsh,0)
                        },1000)
                    }
                }).catch(error => {
                    this.$message.error(error);
                })
            })
        },
        handleCall(val){
            console.log(val)
            this.getList();
        }
    }
}
</script>


<style scoped>
.beizhu{color: #ff0000;}
.shibieW{width: 100%; overflow: hidden;}
.shibie{float: left; width: calc((100% - 30px) / 2 ); height: 70vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.shibie >>> .el-scrollbar { width: 100%; height: 100%;}
.shibie >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.shibie >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.shibie >>> .el-scrollbar__view{min-height: 100%;}
.right .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.shibieW .right{float: right;}
.shibie h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.shibie ul{width: 180px;margin-right: 10px;}
.shibie ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.shibie ul li.active{color:#1890ff;}
.imgW{width: calc(100% - 214px);  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
.pcTk >>> .el-dialog{height: 90vh;}
.pcTk2 >>> .el-dialog{max-height: 96vh;}
.imgW >>> .el-textarea.is-disabled .el-textarea__inner ,.imgW >>> .el-input.is-disabled .el-input__inner { color: #606266;}
.shangchuan >>> .el-upload,.shangchuan >>> .el-upload-dragger {width:100%;}
.newTk >>> .el-loading-spinner .el-loading-text{color:#fff;}
.newTk >>> .el-loading-spinner .path{stroke: #FFF;}
.content >>> .el-date-editor.el-input,.content >>> .el-date-editor.el-input__inner{width:140px;}
</style>